module.exports = __webpack_public_path__ + "assets/2-chicago-sales-recruiting-agency.59ad3dda.png";